var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: _vm.$style.click },
    [
      _c(
        "div",
        {
          class: _vm.$style.container,
          on: {
            click: function($event) {
              _vm.isModalOpen = true
            }
          }
        },
        [
          _c("p", [
            _vm._v(_vm._s(_vm.$t("notice", { closingTime: _vm.closingTime })))
          ])
        ]
      ),
      _vm._v(" "),
      _vm.isModalOpen
        ? _c("modal-app-closing", {
            on: {
              cancel: function($event) {
                _vm.isModalOpen = false
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }